/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/grupo'

export default {
    get: params => {
        let customRoute = `${route}?grado_id=${params.gradoID}&expand=empleado,status_description&search=${params.filter}`
        switch (params.grupoEstado) {
            case "2": customRoute = `${route}?estado=1&grado_id=${params.gradoID}&expand=empleado,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&grado_id=${params.gradoID}&expand=empleado,status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=empleado,status_description`, payload),
    getAllRecords: () => Api().get(`${route}?fields=id,letra&expand=status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=empleado,status_description,history`, { crossDomain: true }),
    put: payload => Api().put(`${route}/${payload.id}?expand=empleado,status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}&expand=empleado,status_description`)
}
